export default {
  navigationBarTitleText: '申请开票'
};
